<script setup>
import { ref } from 'vue';
import { useI18n } from 'vue-i18n';
import TextArea from 'dashboard/components-next/textarea/TextArea.vue';
import Button from 'dashboard/components-next/button/Button.vue';

defineProps({
  results: {
    type: Array,
    default: () => [],
  },
  isLoading: {
    type: Boolean,
    default: false,
  },
  asked: {
    type: Boolean,
    default: false,
  },
});

const emit = defineEmits(['ask']);

const { t } = useI18n();
const question = ref('');

const submit = () => {
  const value = question.value.trim();
  if (!value) return;
  emit('ask', value);
};
</script>

<template>
  <section class="flex flex-col gap-3">
    <h2 class="text-base font-medium text-n-slate-12">
      {{ t('ONIX.KNOWLEDGE.ASK_TITLE') }}
    </h2>
    <TextArea
      v-model="question"
      :placeholder="t('ONIX.KNOWLEDGE.ASK_PLACEHOLDER')"
      :max-length="2000"
      auto-height
      min-height="4rem"
    />
    <Button
      :label="t('ONIX.KNOWLEDGE.ASK')"
      size="sm"
      class="self-start"
      :disabled="!question.trim()"
      :is-loading="isLoading"
      @click="submit"
    />
    <ul v-if="results.length" class="m-0 p-0 list-none flex flex-col gap-2">
      <li
        v-for="(result, index) in results"
        :key="result.id || index"
        class="p-3 rounded-xl bg-n-solid-2 outline outline-1 outline-n-container text-sm text-n-slate-12 whitespace-pre-wrap"
      >
        {{ result.content || result.text }}
      </li>
    </ul>
    <p v-else-if="asked && !isLoading" class="text-sm text-n-slate-11">
      {{ t('ONIX.KNOWLEDGE.ASK_EMPTY') }}
    </p>
  </section>
</template>
